export const ERROR_CODES = {
  REACH_OUT_LIMIT_REQUIRED_VERIFIED: "REACH_OUT_LIMIT_REQUIRED_VERIFIED",
  REACH_OUT_LIMIT: "REACH_OUT_LIMIT",
};
